import { BasicDataKeys } from '~/client/src/shared/components/ListWithFixedColumns/VirtualListHelpers'

enum SpecificDataKeys {
  NAME = 'name',
  STATUS = 'status',
  PROCUREMENT_ID = 'procurement-id',
  PLANNED_INSTALL_LOCATION = 'planned-install-location',
  PLANNED_DELIVERY_LOCATION = 'planned-delivery-location',
  VENDOR = 'vendor',
  TOTAL_ON_SITE_QUANTITY = 'total-on-site-quantity',
  CURRENT_MATERIAL_LOCATION = 'current-material-location',
  REQUIRED_ON_SITE_DATE = 'required-on-site-date',
  NEXT_DELIVERY = 'next-delivery',
  NEXT_DELIVERY_BOOKING_DATE = 'next-delivery-booking-date',
  BOOKED_QUANTITY = 'booked-quantity',
  RECORDED_LAST_UPDATED = 'recorded-last-updated',
  PRODUCT_CATEGORY = 'product-category',
  RESPONSIBLE_COMPANY = 'responsible-company',
  MATERIAL_NOTE = 'material-note',

  PLANNED_QUANTITY = 'planned-quantity',
  DESCRIPTION = 'description',
  REMAINING_QUANTITY = 'remaining-quantity',
  PERCENT_COMPLETE = 'percent-complete',
  READY_TO_INSTALL_QUANTITY = 'ready-to-install-quantity',
  TO_MOVE_QUANTITY = 'to-move-quantity',

  MATERIAL_TRANSFER_ID = 'material-transfer-id',
  MATERIAL_TRANSFER_DATE = 'material-transfer-date',
}

export const MaterialsDataKeys = { ...BasicDataKeys, ...SpecificDataKeys }
